// The order of groups and fields inside groups is IMPORTANT. It will do the sorting of columns following the sequence from here.
// However, on UI they will be sorted alphabetically
export const competitionsExportFields = [
  {
    titleIntlKey: "competitions.columns.competition.title",
    fields: [
      "competitionId",
      "forceCompetitionId",
      "externalId",
      "abbreviationLatin",
      "abbreviationLocal",
      "ageGroup",
      "eventType",
      "internationalReference",
      "nameLatin",
      "nameLocal",
    ],
  },
  {
    titleIntlKey: "competitions.columns.league.title",
    fields: ["leagueId", "leagueExternalId", "leagueName"],
  },
  {
    titleIntlKey: "competitions.columns.social.title",
    fields: ["socialFacebook", "socialInstagram", "socialTwitter", "socialWebsite", "socialWikipedia"],
  },
];

export const defaultCompetitionsExportFieldNames = ["leagueName", "competitionId", "ageGroup", "nameLocal"];
